import React from 'react';

const styles = {
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '64px 24px',
        textAlign: 'center',
        color: '#39433d',
    },
    title: {
        margin: '0 0 12px',
        fontSize: '1.8rem',
        fontWeight: 700,
    },
    body: {
        margin: 0,
        maxWidth: '420px',
        fontSize: '1.35rem',
        lineHeight: 1.5,
        color: '#5f6f66',
    },
};

/**
 * Placeholder body shown in standalone mode while no scenario user has been
 * seeded yet. Rendered by `App` in place of `AppRoutes` so the Dashboard and
 * its data-fetching effects don't mount with the default `admin@ghost.org`
 * test email (which does not exist in Daisy until seeding completes).
 *
 * @returns {JSX.Element}
 */
function UnseededStandalonePlaceholder() {
    return (
        <section
            className="standalone-unseeded-placeholder"
            data-test-id="standalone-unseeded-placeholder"
            style={styles.wrapper}
        >
            <h2 style={styles.title}>No user seeded yet</h2>
            <p style={styles.body}>
                Use the standalone seeding panel to create a scenario user. The app will reload with
                that user once seeding completes.
            </p>
        </section>
    );
}

export default UnseededStandalonePlaceholder;
